<template>
  <entry-point-page-template
    class="localized-text"
    :hashed-data-id="hashedDataId"
    :doctor-slug="doctorSlug"
  >
    <template #placeholder>
      <welcome-section v-if="initialPageData" is-loading />
      <app-spinner class="global-spinner" transparent-mode data-global-spinner />
    </template>

    <welcome-section v-if="initialPageData" @next="onLetsGo" />

    <cookie-consent />
  </entry-point-page-template>
</template>

<script>
import { mapState } from 'vuex';

import WelcomeSection from '@/components/welcome-section/WelcomeSection.vue';
import CookieConsent from '@/components/welcome-page/CookieConsent.vue';
import EntryPointPageTemplate from '@/views/EntryPointPageTemplate.vue';
import AppSpinner from '@/components/common/AppSpinner.vue';

import { types } from '@/store/types';

export default {
  name: 'WelcomePage',
  components: {
    CookieConsent,
    WelcomeSection,
    EntryPointPageTemplate,
    AppSpinner
  },
  props: {
    hashedDataId: {
      type: String,
      required: true
    },
    doctorSlug: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      shouldShowWelcomeSectionAnimation: false,
      isDiscoverSidebarOpened: false,
      discoverComponent: '',
      isLoaded: false
    };
  },
  computed: {
    ...mapState({
      initialPageData: types.state.INITIAL_PAGE_DATA
    })
  },
  methods: {
    async onLetsGo() {
      await this.$router.push({
        name: 'MainPage'
      });
    }
  }
};
</script>
